/**
 * Constants used throughout the return date calculator
 */

export const TIME_CONSTANTS = {
    MINUTES_PER_HOUR: 60,
    MILLISECONDS_PER_DAY: 24 * 60 * 60 * 1000,
    HOURS_5PM: 17,
    HOURS_530PM_MINUTES: 30,
    HOURS_6PM: 18,
    HOURS_9AM: 9,
    HOURS_12PM: 12,
    MINUTES_30: 30,
    MINUTES_0: 0,
} as const;

export const BUSINESS_RULES = {
    EARLY_CLOSE_WARNING_MINUTES: 60, // 1 hour before close
    MAX_CONSECUTIVE_DAYS_CHECK: 14, // Safety limit for closure checking
} as const;

export const TOAST_IDS = {
    RETURNING_SUNDAY: 'returningSunday',
} as const;

export const VEHICLE_TYPES = {
    CAR: 'car',
    VAN: 'van',
} as const;

export const CLOSURE_TYPES = {
    CLOSED_ALL_DAY: 'closed',
} as const;

export const LOCALE_DATE_FORMAT = 'en-GB'; // Used for date formatting in the application
